<template>
  <div class="flex flex-row">
    <div class=" h-screen w-80  border-gray-200 bg-white">
      <img src="./assets/navplaceholder.png" class="h-screen" >
      
    </div>

    <div class="w-full h-screen overflow-y-scroll">
      <NavBar />

      <div class="p-8 flex flex-col justify-start">
       <Transactions />
      </div>
    </div>
  </div>
</template>

<script>
import "./assets/tailwind.css";
import NavBar from "./components/NavBar";
import Transactions from "./components/Settlements.vue";



export default {
  name: "App",
  components: {
    NavBar,
    Transactions
},
};
</script>



<style>
  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.5s ease;
  }
  
  .v-enter-from,
  .v-leave-to {
    opacity: 0;
  }
  </style>